function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";

/**
 * An unstyled Tag component.
 *
 * Props:
 * - label: (string) The text content of the tag.
 * - onClick: (function) The function to call when the tag is clicked. (optional)
 * - ...rest: (props) Additional props to be passed to the underlying HTML element.
 */

const UnstyledTag = ({
  classPrepend = 'unstyled',
  label = "",
  closable = false,
  onClose = null,
  icon = null,
  color = null,
  bordered = false,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `${classPrepend}-tag ${bordered ? ` ${classPrepend}-tag-bordered` : ""} ${color ? ` ${classPrepend}-tag-color-${color}` : ""}`
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    className: `${classPrepend}-tag-icon`
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: `${classPrepend}-tag-label`
  }, label), closable && /*#__PURE__*/React.createElement("span", {
    className: `${classPrepend}-tag-close-button`,
    onClick: onClose
  }, "\u2715"));
};
export { UnstyledTag };